<template>
  <div class="image-preview" id="image-preview" v-if="image">
    <img
      id="imagepreview"
      crossOrigin="anonymous"
      class="d-none"
      :src="`${image}?time=${date}`"
    />
    <img
      :src="image"
      alt=""
      class="image-preview__image is-rotate"
      style="
        transform: translate(0px, 0px) rotate(0deg) scale(1)
          matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        object-fit: contain;
      "
    />
    <div class="image-preview__action-layer">
      <div
        class="image-preview__close image-preview__cir-action"
        id="image-preview__close"
        @click="$emit('close')"
      >
        <feather-icon icon="XIcon" size="22" />
      </div>
      <div
        class="image-preview__download action-btn image-preview__cir-action"
        @click="download"
      >
        <feather-icon icon="ArrowDownCircleIcon" size="22" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      date: "",
    };
  },
  methods: {
    getBase64ImageUrl(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      var dataURL = canvas.toDataURL("image/png");
      return dataURL;
    },
    base64ToBlob(code) {
      let parts = code.split(";base64,");
      let contentType = parts[0].split(":")[1];
      let raw = window.atob(parts[1]);
      let rawLength = raw.length;
      let uInt8Array = new Uint8Array(rawLength);
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], {
        type: contentType,
      });
    },
    download() {
      this.date = new Date().getMilliseconds();
      var url = this.getBase64ImageUrl(document.getElementById("imagepreview"));
      let a = document.createElement("a");
      let blob = this.base64ToBlob(url);
      let evt = document.createEvent("HTMLEvents");
      evt.initEvent("click", true, true);
      let name = this.image.replace(/^.*[\\\/]/, "");
      a.download = name.substring(name.indexOf("_") + 1);
      a.href = URL.createObjectURL(blob);
      a.click();
    },
  },
};
</script>